import { InfoBoxTitle, InfoBoxWrapper, StyledTextArea } from "./Styled";

interface NoteProps {
    text: string;
    setText: Function;
    isView?: boolean;
    compact?: boolean;
}

const Note = ({ text, setText, isView, compact }: NoteProps) => {
    return (
        <InfoBoxWrapper style={compact ? { padding: "16px", gap: "12px" } : undefined}>
            <InfoBoxTitle style={compact ? { fontSize: "16px", lineHeight: "22px" } : undefined}>Ghi chú</InfoBoxTitle>
            {!isView && (
                <StyledTextArea
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Nhập ghi chú tại đây"
                    minRows={compact ? 2 : undefined}
                    style={compact ? { fontSize: "13px", lineHeight: "20px", padding: "8px 10px" } : undefined}
                />
            )}

            {isView && <div className="text">{text}</div>}
        </InfoBoxWrapper>
    );
};

export default Note;
